import { render, staticRenderFns } from "./Announcement.vue?vue&type=template&id=79360214&"
import script from "WX/components/Announcement/Announcement.component?vue&type=script&lang=js&"
export * from "WX/components/Announcement/Announcement.component?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports